/** KAN-752: операторы рассылки для ссылок на их приветствия. */
import { operatorLabel } from '@/lib/channelOperators';

export interface AccountOperator {
  operator_id: string;
  operator_email: string;
  /** Имя, которым оператор представляется (если пришло в данных). */
  operator_display_name?: string | null;
  operator_full_name?: string | null;
}

/** Оператор канала из GET /users/channel-operators/. */
export interface NamedOperator {
  id: string;
  name: string;
  email: string;
}

export interface GreetingOperator {
  id: string;
  label: string;
}

/**
 * Операторы аккаунтов и операторы канала без повторов. Подпись - имя
 * (operator_display_name, full_name или name из списка канала), email только
 * если имени нет; служебные email кампаний не показываются.
 */
export function greetingOperators(
  accounts: ReadonlyArray<AccountOperator>,
  channelOperators: ReadonlyArray<NamedOperator> = []
): GreetingOperator[] {
  const byId = new Map<string, { name: string; email: string }>();
  for (const op of channelOperators) {
    if (op.id && !byId.has(op.id)) byId.set(op.id, { name: op.name ?? '', email: op.email ?? '' });
  }
  for (const a of accounts) {
    if (!a.operator_id) continue;
    const name = a.operator_display_name?.trim() || a.operator_full_name?.trim() || '';
    const known = byId.get(a.operator_id);
    if (!known) byId.set(a.operator_id, { name, email: a.operator_email });
    else if (!known.name.trim() && name) known.name = name;
  }
  return [...byId.entries()]
    .map(([id, op]) => ({ id, label: operatorLabel(op.name, op.email) }))
    .sort((x, y) => x.label.localeCompare(y.label));
}

/** Вкладка "Приветствия A/B" на странице оператора. */
export function greetingsHref(operatorId: string): string {
  return `/users/${operatorId}?tab=greetings`;
}
